import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { ColorRing } from 'react-loader-spinner';
import { useGetHigherLevelMarketIntelligenceGridataQuery, useGetShapeSizeDistributionQuery } from '../../redux/slices/apiSlice';
import { pricing, setPreDefinedSearchId, setPreDefinedSort } from '../../redux/slices/pricingSlice';
import debounce from 'lodash/debounce';
import amplitude from '../../utils/ampli';
import TopFilterDrawer from '../ui/topFilterDrawer';
import PerformanceFilterDrawer from '../ui/performanceFilterDrawer';
import { cn } from '../../utils/utils';
import { FilterIcon } from 'lucide-react/dist/cjs/lucide-react';
import MIShapeCaratGrid from './MIShapeCaratGrid';
import { FormControl, InputLabel, MenuItem, Select } from '@mui/material';
import { setFilteredPerformanceRedux } from '../../redux/slices/miShapeCaratSlice';

const MarketIntelligence = ({ isCsr, accountDetails }) => {
  const {
      selectedLocation
    } = useSelector((state) => state.marketIntelligenceShapeCarat);
  const dispatch = useDispatch();
  const [weeks, setWeeks] = useState(4);
  const [diamondKeys, setDiamondKeys] = useState([]);
  const [gridDatas, setGridDatas] = useState([]);
  const [allCaratRanges, setAllCaratRanges] = useState([]);
  const [openDrawer, setOpenDrawer] = useState(false);
  const [isResetting, setIsResetting] = useState(false);
  const {
      selectedNeedsMetric  
    } = useSelector((state) => state.marketIntelligenceShapeCarat);
  // selectedNeedsMetric
  
  
  const locationOptions = {
    "1000global": "Global",
    "0000india": "India",
    "0001usa": "USA",
  };

  // [] or 
  const {
    data,
    error,
    isLoading,
    refetch,
    isFetching
  } = useGetHigherLevelMarketIntelligenceGridataQuery({
    id: accountDetails.account_id,
    location: selectedLocation,
    duration_in_weeks: selectedNeedsMetric,
  }, {
    // This ensures the query is refetched when selectedNeedsMetric changes
    refetchOnMountOrArgChange: true
  });
 
  // Handle data processing when API response changes
  useEffect(() => {
    if (data?.data) {

      const keys = Object.keys(data.data);
      setDiamondKeys(keys);

      const mappedData = Object.values(data.data).map(category =>
        Object.entries(category)
          .filter(([key]) => key !== 'trans')
          .map(([, value]) => value)
      );
      setGridDatas(mappedData);

      const caratRanges = Object.keys(data.data[keys[0]])
        .filter(caratRange => caratRange !== "trans");

      setAllCaratRanges(caratRanges);
    }
  }, [data, selectedNeedsMetric]);

  const handleLocationChange = (metric) => {
      dispatch(setFilteredPerformanceRedux(metric));
      const buttonClickedEvent = {
        event_type: `v3_location_change`,
        value: metric,
      };
    amplitude.track(buttonClickedEvent);
  };

  useEffect(() => {
    if (selectedNeedsMetric) {
      // Force a refetch when selectedNeedsMetric changes
      // refetch();
    }
  }, [selectedNeedsMetric]);

  useEffect(() => {
    if (selectedNeedsMetric) {
      // Force a refetch when selectedNeedsMetric changes
      // refetch();
    }
  }, [selectedLocation]);
  
  

  // Show loading state for initial load or date changes
  const showLoading = isLoading || isFetching;
  return (
      <div className="px-5 py-6 ">
      
        {/* <MIPerformanceFilter
        
          open={openDrawer}
          onClose={(ev) => toggleDrawer(ev)}
          filtered={filtered}
          setFiltered={(value) => {
            setFiltered(value);
          }}
          setIsResetting={setIsResetting}
        /> */}
        <div className='w-full px-48 flex justify-end'>        
      </div>
      <div className="pagetitle text-center flex justify-center mx-auto">
        <h1 className='w-[675px] ml-12 text-right'>SHAPE CARAT DISTRIBUTION</h1>
        
        <div className={cn(
                "self-end flex items-center justify-center w-max font-medium text-[0.75rem] ml-[272px] bg-transparent"    
              )}>
        <FormControl size="small">
        <div className="flex justify-between gap-4 items-center">
        <InputLabel>Location</InputLabel>
          <Select
            value={selectedLocation}
            style={{ minWidth: 118 }}
            label="Location"
          >
            {Object.entries(locationOptions).map(([value, label]) => (
              <MenuItem key={value} value={value} onClick={() => handleLocationChange(value)}>
                {label}
              </MenuItem>
            ))}
          </Select>
          </div>
        </FormControl>
        </div>
      </div>
      
      <div className="mt-4">
        {showLoading ? (
          <div className="flex justify-center items-center h-20">
            <ColorRing
              visible={true}
              height="60"
              width="60"
              ariaLabel="blocks-loading"
              colors={["#00319f", "#2e56b1", "#5c7bc2", "#8aa1d3", "#b2c1e2"]}
            />
          </div>
        ) : data?.data ? (
          <MIShapeCaratGrid
            isCsr={isCsr}
            accountDetails={accountDetails}
            caratRanges={allCaratRanges}
            shapes={diamondKeys}
            gridData={gridDatas}
            defaultTurn={1}
            data={data.data}
            isResetting={isResetting}
            weeks={weeks}

          />
        ) : (
          <div className="flex justify-center">
            No data available
          </div>
        )}
      </div>
    </div>
  );
};

export default MarketIntelligence;